<template>
  <div class="navBar">
    <div class="navBarLeft">
      <div class="navContent">
        <!-- <img @click="goback()" v-show="pageBack" src="../assets/images/common/icon-back.png" class="pageBack" alt=""> -->
        <p class="navTitle">
          <span
            v-for="(item, index) in convertList"
            :key="index"
            class="navTitleOne"
            @click="navigateBack(index)"
          >
            {{ item }} /
          </span>
          <span>{{ navtitle }}</span>
        </p>
      </div>
      <div class="name_font">
        <div class="img-box">
          <img v-if="avatarPic" :src="avatarPic" alt="" />

          <img v-else src="@/assets/images/common/roleImg.png" alt="" />
        </div>
        <p v-if="nickname" class="loginName">{{ nickname }}</p>

        <p v-else class="loginName">{{ name }}</p>
        <p
          v-show="role == '1'"
          class="loginName"
          style="margin-left:0;margin-right:0.1rem;font-weight: 600;"
        >
          测试人员
        </p>
      </div>
    </div>

    <div class="divideLine"></div>

    <div class="loginout" @click="loginout()">
      <div class="loginoutWrap"><span>退出</span></div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from "mint-ui";
export default {
  props: ["navBlock", "navtitle", "pageBack"],
  data() {
    return {
      role: "",
      name: "",
      avatarPic: "",
      nickname: "",
      convertList: []
    };
  },
  mounted() {
    // document.getElementsByClassName('loginName')[0].innerHTML = localStorage.getItem('role');
  },
  created() {
    // console.log(this.$route.path);
    this.convert();

    this.name = localStorage.getItem("role");

    this.nickname = localStorage.getItem("nickName");

    this.role = localStorage.getItem("testRole");

    let getAvatarPic = localStorage.getItem("avatarPic");

    if (getAvatarPic !== 'null' && getAvatarPic) {
      this.avatarPic = localStorage.getItem("avatarPic");
    }
    
  },

  activated() {
    this.convert();
    this.name = localStorage.getItem("role");

    this.nickname = localStorage.getItem("nickName");

    this.role = localStorage.getItem("testRole");

    let getAvatarPic = localStorage.getItem("avatarPic");

    if (getAvatarPic !== 'null' && getAvatarPic) {
      this.avatarPic = localStorage.getItem("avatarPic");
    }
  },
  methods: {
    convert() {
      let convert = this.navBlock.split(" / ");
      console.log(convert);
      this.convertList = convert;
    },
    navigateBack(index) {
      console.log(this.convertList);
      if (this.convertList.length == 1) {
        return;
      } else {
        let idx;
        if (index == 0) {
          idx = 1 - this.convertList.length;
        } else {
          idx = index - this.convertList.length;
        }
        this.$router.go(idx);
      }
    },
    goback() {
      let _this = this;
      _this.$router.go(-1);
    },
    loginout() {
      let _this = this;
      _this
        .$confirm("是否退出登錄?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          //確認退出登錄
          let param = {};
          _this.$post("/logout", param, _this.$GLOBAL.jsonConfig).then(res => {
            Toast({
              message: res.msg
            });
            Indicator.open("正在退出...");
            localStorage.clear();
            setTimeout(function() {
              Indicator.close();
              _this.$router.push("/login");
              _this.$cookie.remove("auth");
            }, 2000);
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.navBar {
  height: 0.8rem;
  line-height: 0.8rem;
  padding: 0.2rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  z-index: 100;
  background: #fafafd;
  box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    // top: 0.8rem;
  }
  @media (min-width: 769px) {
    width: calc(100% - 2.2rem);
  }
  .navBarLeft {
    width: calc(100% - 1.08rem);
    height: 100%;
    display: flex;
    justify-content: space-between;

    .navContent {
      padding-left: 0.6rem;
      line-height: 0.4rem;
      color: #292929;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .pageBack {
        margin-right: 20px;
        width: 14px;
      }
      p.navTitle {
        width: 100%;
        height: 100%;
        color: rgba(147, 142, 164, 1);
        font-size: 0.12rem;
        .navTitleOne {
          color: rgba(147, 142, 164, 1);
          font-size: 0.12rem;
          cursor: pointer;
        }
        span {
          color: rgba(41, 41, 41, 1);
        }
      }
      p {
        @media (max-width: 768px) {
          font-size: 0.2rem;
        }
        @media (min-width: 769px) {
          font-size: 0.16rem;
        }
      }
    }

    .name_font {
      height: 0.4rem;
      display: flex;
      justify-content: flex-start;
      .img-box {
        width: 0.4rem;
        height: 0.4rem;
        overflow: hidden;
        border-radius: 50%;
        img {
          width: 0.4rem;
          height: 0.4rem;
          display: block;
        }
      }
      p.loginName {
        line-height: 0.4rem;
        margin-left: 0.2rem;
        margin: 0 0.3rem 0 0.2rem;
      }

      @media (max-width: 768px) {
        right: 160px;
      }
      @media (max-width: 420px) {
        right: 65px;
        font-size: 12px;
      }
    }
  }
  .divideLine {
    height: 0.2rem;
    width: 0.01rem;
    background: #adadad;
  }
  .loginout {
    width: 1rem;
    height: 100%;
    padding: 0 0.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #919191;
    cursor: pointer;
    @media (max-width: 768px) {
      right: 100px;
    }
    @media (max-width: 420px) {
      right: 0;
    }
    .loginoutWrap {
      height: 0.35rem;
      color: @mainColor;
      font-weight: 500;
      letter-spacing: 2px;
      border-bottom: 1px solid @mainColor;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      span {
        font-size: 0.14rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue